__turbopack_context__.v({
  "location": "StickyInfo-module__zdOPoW__location",
  "modalBody": "StickyInfo-module__zdOPoW__modalBody",
  "modalContainer": "StickyInfo-module__zdOPoW__modalContainer",
  "sentinel": "StickyInfo-module__zdOPoW__sentinel",
  "stickyInfo": "StickyInfo-module__zdOPoW__stickyInfo",
  "stockUnavailable": "StickyInfo-module__zdOPoW__stockUnavailable",
});
